import classnames from 'classnames'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './button.module.scss'

const Button = ({
  className,
  children,
  disabled,
  icon,
  iconClassName,
  iconOnly,
  intent,
  isSelected,
  large,
  raised,
  small,
  onClick
}) => {
  const intentNone = intent === 'none'
  const buttonClassName = classnames(className, styles.btn, {
    'is-active': isSelected,
    [styles.none]: intentNone,
    [styles.default]: intent === 'default',
    [styles.brand]: intent === 'brand',
    [styles.primary]: intent === 'primary',
    [styles.danger]: intent === 'danger',
    [styles.raised]: raised,
    [styles.large]: large && !intentNone,
    [styles.small]: small && !intentNone,
    [styles.medium]: !large && !small && !intentNone,
    [styles.iconOnly]: iconOnly
  })

  return (
    <button type="button" className={buttonClassName} disabled={disabled} onClick={onClick}>
      {icon ? <i className={classnames(icon, iconClassName)} /> : null}
      {children}
    </button>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  iconOnly: PropTypes.bool,
  intent: PropTypes.string,
  isSelected: PropTypes.bool,
  large: PropTypes.bool,
  raised: PropTypes.bool,
  small: PropTypes.bool,
  onClick: PropTypes.func
}

Button.defaultProps = {
  className: null,
  children: null,
  disabled: false,
  icon: null,
  iconClassName: null,
  iconOnly: false,
  intent: 'none',
  isSelected: false,
  large: false,
  raised: false,
  small: false,
  onClick: noop
}

export default Button
